export default "__VITE_ASSET__CXU4I6sg__"